/* unplugin-vue-components disabled */import { render } from "./AndroidView.vue?vue&type=template&id=2bd258e1&scoped=true"
import script from "./AndroidView.vue?vue&type=script&lang=js"
export * from "./AndroidView.vue?vue&type=script&lang=js"

import "./AndroidView.vue?vue&type=style&index=0&id=2bd258e1&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd258e1"]])

export default __exports__